<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت کدهای تخفیفی</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;کد تخفیف جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingItems" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.cP_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.cP_Id)" dark v-if="!item.cP_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.cP_Id)" dark v-else> فعال</v-btn>
                            </template>
                            <template v-slot:[`item.cP_UseInSearch`]="{ item }">
                               <v-chip small v-if="item.cP_UseInSearch" color="success">
                                 بله
                                </v-chip>
                                <v-chip small  v-else color="error">
                                 بله
                                </v-chip>
                            </template>
                            
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.cP_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New Cat From Dialog-->
            <v-dialog max-width="500" persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت کد تخفیف جدید</span>
                              <span v-else>ویرایش کد تخفیف  &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="CatCreationDialog = false" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;padding-top:0px !important;"><!--Register New Color From-->
                                    
                                    <v-text-field color="#2a2d45" outlined dense v-model="AttributeTitle" label="عنوان" ></v-text-field>
                                   
                                    <v-text-field style="direction:ltr !important"  color="#2a2d45" outlined dense v-model="AttrSortField" label="کد تخفیف" ></v-text-field>

                                    <!-- <v-autocomplete :items="AttributeTypeItems" item-text="text" item-value="value" no-data-text="موردی یافت نشد" v-model="AttrType" color="#2a2d45" outlined dense label="نوع کد تخفیف "></v-autocomplete> -->
                                    
                                    <v-text-field color="#2a2d45" outlined dense v-model="Discount" label="درصد تخفیف" ></v-text-field>
                                    
                                    <v-menu
                                    ref="StartDateRef"
                                    v-model="StartDateMenu"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="StartDate"
                                            label="از"
                                            hint="MM/DD/YYYY format"
                                            persistent-hint
                                            v-bind="attrs"
                                            @blur="StartDate = parseDate(StartDate)"
                                            v-on="on"
                                            readonly
                                            color="#2a2d45" outlined dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="StartDate"
                                            locale="fa-IR"
                                            no-title
                                            @input="StartDateMenu = false"
                                        ></v-date-picker>
                                    </v-menu>

                                    <v-menu
                                    ref="EndDateRef"
                                    v-model="EndDateMenu"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="EndDate"
                                            label="تا"
                                            hint="MM/DD/YYYY format"
                                            persistent-hint
                                            v-bind="attrs"
                                            @blur="EndDate = parseDate(EndDate)"
                                            v-on="on"
                                            readonly
                                            color="#2a2d45" outlined dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="EndDate"
                                            locale="fa-IR"
                                            no-title
                                            @input="EndDateMenu = false"
                                        ></v-date-picker>
                                    </v-menu>

                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="AttrStatus" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>
                                   
                                    

                                    <v-btn style="margin-top:20px;" @click="registerItem" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>
<style>
.v-color-picker__canvas canvas
{
    display: block !important;
    min-width: 100% !important;
    height: 100% !important;
}
</style>
<script>

const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
export default {
   name:"coppon",
   components: 
   {
      Loading,
      JsonExcel
        
    },
    data:()=> ({
        StartDateMenu:false,
        AttrType:1,
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        CatCreationDialog:false,
        searchcategory:"",
        isLoadingItems:false,
        AttrStatus:false,
        UseInSearch:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"کد تخفیف ",value:"cP_Code",sortable:true,align:"right"},
            {text:"عنوان ",value:"cP_Title",sortable:true,align:"right"},
            {text:"درصد تخفیف",value:"cP_Discount",sortable:true,align:"right"},
            {text:"از تاریخ",value:"cP_StartDate",sortable:true,align:"right"},
            {text:"تا تاریخ",value:"cP_EndDate",sortable:true,align:"right"},
            {text:"وضعیت",value:"cP_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        AttributeTitle:"",
        AttrSortField:"",
        originalItems:[],
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "کد":"cP_Id",
            "عنوان":"cP_Title",
            // "نوع کد تخفیف ":"cP_Type",
            "استفاده در جستجو":"cP_UseInSearch",
            "ترتیب نمایش":"cP_SortField",
            "وضعیت":"cP_Status"
        },
        AttributeTypeItems:[
            {text:"محصولات فیزیکی",value:1}
        ],
        date:"",
        sdate:"",
        StartDate:"",
        EndDateMenu:false,
        EndDate:"",
        Discount:0
    }),
    async created()
    {
        let vm = this;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadItems();
    },
    methods:{
        parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
        getAttrText(v)
        {
            let vm = this;
            let title = "";
            vm.AttributeTypeItems.forEach(i=>{
                if(i.value == v)
                {
                    title= i.text;
                }
            });
            return title;
        },
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.cP_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteCoppon,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.cP_Id = id;
            await axios.post(ApiUrl.ActiveCoppon,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.cP_Id = id;
            await axios.post(ApiUrl.DisableCoppon,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.AttributeTitle = "";
            vm.inEditingItem = false;
            vm.AttributeTitle = "";
            vm.AttrSortField = "";
            vm.AttrType = "";
            vm.StartDate = "";
            vm.EndDate = "" ;
            vm.AttrStatus = true;
            vm.Discount = 0;
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
        },
        editItem(item)
        {
            let vm = this;
            vm.CatCreationDialog = true;
            vm.AttributeTitle = item.cP_Title;
            vm.AttrSortField = item.cP_Code;
            vm.AttrType = item.cP_Type;
            var sd = item.cP_StartDate.split('T');
            var ed = item.cP_EndDate.split('T');
            vm.StartDate = sd[0];
            alert(sd[0]);
            vm.EndDate = ed[0] ;
            vm.AttrStatus = item.cP_Status;
            vm.Discount = item.cP_Discount;
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
        },
        async loadItems()
        {
            let vm = this;
            vm.isLoadingItems = true;

            await axios.post(ApiUrl.LoadCoppon).then((res)=>{
                vm.isLoadingItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                    
                    console.warn(data.data);
                    
                }
            }).catch((err)=>{
                vm.isLoadingItems = false;
                console.error(err);
            });
        },
        async registerItem()
        {
            let vm = this;
            let Model = {};
            Model.CP_Title = vm.AttributeTitle;
            Model.CP_Type = vm.AttrType;
            Model.CP_Code = vm.AttrSortField;
            Model.CP_Discount = vm.Discount;
            Model.CP_Status = vm.AttrStatus;
            Model.CP_SD = vm.StartDate;
            Model.CP_ED = vm.EndDate;
          
            let url = ApiUrl.registerCoppon;
            if(vm.inEditingItem)
            {
                Model.CP_Id = vm.EditSelectedItem.cP_Id;
                url = ApiUrl.updateCoppon;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadItems();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        }
    }
}
</script>